// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"call-to-action-wrapper_callToAction__VMZGc"};